import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import Button from '@atlaskit/button';

import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';

import { EmptyStateWrapper } from './EmptyStateWrapper';
import EmptyFeaturedImg from './EmptyFeatured.svg';

const i18n = defineMessages({
	errorHeaderMyTemplates: {
		id: 'template-list.templates.empty.my-templates.header',
		// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: "You don't have any custom or saved templates",
		description:
			'Text that appears when there are no templates in My Templates category in the template list',
	},
	errorHeaderMyTemplatesForEP: {
		id: 'template-list.templates.empty.my-templates.header.ep',
		defaultMessage:
			// eslint-disable-next-line no-restricted-syntax
			"Embedded pages don't yet support custom and saved templates",
		description:
			'Text that appears when there are no templates in My Templates category in the template list for EP',
	},
	errorDescriptionMyTemplates: {
		id: 'template-list.templates.empty.my-templates.description',
		defaultMessage: 'Templates you create or star will show up here.',
		description:
			'Text that encourages the user to add templates to the My Templates category in the template list',
	},
	errorDescriptionMyTemplatesForEP: {
		id: 'template-list.templates.empty.my-templates.description.ep',
		defaultMessage: 'Open Confluence in a new browser tab to access your custom templates',
		description:
			"Text that encourages the user to add templates from Confluence app as EP doesn't supports custom templates",
	},
	callToActionLinkMyTemplates: {
		id: 'template-list.templates.empty.my-templates.link',
		defaultMessage: 'How to create a template',
		description: 'Call to action link that takes the user to a how-to doc to create a template',
	},
});

export const EmptyMyTemplates = () => {
	const intl = useIntl();
	const isEmbeddedConfluence = isEmbeddedConfluence_DO_NOT_USE();

	return (
		<div data-testid="empty-my-templates-state">
			<EmptyStateWrapper
				header={
					isEmbeddedConfluence
						? intl.formatMessage(i18n.errorHeaderMyTemplatesForEP)
						: intl.formatMessage(i18n.errorHeaderMyTemplates)
				}
				description={
					isEmbeddedConfluence
						? intl.formatMessage(i18n.errorDescriptionMyTemplatesForEP)
						: intl.formatMessage(i18n.errorDescriptionMyTemplates)
				}
				primaryAction={
					!isEmbeddedConfluence && (
						<Button
							appearance="link"
							href="https://support.atlassian.com/confluence-cloud/docs/create-a-template/"
							target="_blank"
							rel="noreferrer noopener"
						>
							{intl.formatMessage(i18n.callToActionLinkMyTemplates)}
						</Button>
					)
				}
				imageUrl={EmptyFeaturedImg}
				imageHeight={180}
				maxImageWidth={220}
			/>
		</div>
	);
};
